package hk.com.vr360_demo2.webapp.component.common

import kotlinx.browser.document

fun toggleFullscreen() {
    val doc = document.asDynamic()
    val elem = document.documentElement
    if (doc.fullscreenElement != null || doc.webkitFullscreenElement != null || doc.mozFullScreenElement != null || doc.msFullscreenElement != null) {
        when {
            doc.exitFullscreen != undefined -> doc.exitFullscreen()
            doc.webkitExitFullscreen != undefined -> doc.webkitExitFullscreen()
            doc.mozCancelFullScreen != undefined -> doc.mozCancelFullScreen()
            doc.msExitFullscreen != undefined -> doc.msExitFullscreen()
        }
    } else {
        val anyElem = elem.asDynamic()
        when {
            anyElem.requestFullscreen != undefined -> anyElem.requestFullscreen()
            anyElem.webkitRequestFullscreen != undefined -> anyElem.webkitRequestFullscreen()
            anyElem.mozRequestFullScreen != undefined -> anyElem.mozRequestFullScreen()
            anyElem.msRequestFullscreen != undefined -> anyElem.msRequestFullscreen()
        }
    }
}
